import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDefined, IsEnum, IsOptional, IsString, ValidateIf, ValidateNested } from 'class-validator';
import { StoreDeliveryAreaTypeEnum, StoreExposeGroup } from '../interface';
import { PatchAbstractStoreCoordinatesDto } from './PatchAbstractStoreCoordinatesDto';
import { PatchStoreDeliveryAreaCircleDto } from './PatchStoreDeliveryAreaCircleDto';
export class PatchStoreDeliveryAreaDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsString({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreDeliveryAreaDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreDeliveryAreaTypeEnum }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsEnum(StoreDeliveryAreaTypeEnum, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreDeliveryAreaDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchAbstractStoreCoordinatesDto, isArray: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    ValidateIf((area) => !area.dataCircle, { groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsArray({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    ValidateNested({ each: true }),
    Type(() => PatchAbstractStoreCoordinatesDto),
    __metadata("design:type", Array)
], PatchStoreDeliveryAreaDto.prototype, "dataPolygon", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreDeliveryAreaCircleDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    ValidateIf((area) => !area.dataPolygon, { groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreDeliveryAreaCircleDto),
    __metadata("design:type", PatchStoreDeliveryAreaCircleDto)
], PatchStoreDeliveryAreaDto.prototype, "dataCircle", void 0);
//# sourceMappingURL=PatchStoreDeliveryAreaDto.js.map